import { inject } from '@angular/core';
import { RESOURCE_SIGNAL_STORE } from '../signals';

export const resourceResolver = () => {
  const resourceSignalStore = inject(RESOURCE_SIGNAL_STORE);
  resourceSignalStore.fetchResources();
  return !!resourceSignalStore.$resources();
};
